import React, { Component } from 'react';
import { notification, Input, Button, Icon, Spin, Pagination, Select, Modal, message, Row, Col, Form } from 'antd';
import * as actions from "../../actions/index";
import { compose } from "recompose";
import { history } from '../../container/History';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Iframe from '../HOC/iframe';
import { each } from 'lodash';
import { nationalAwards } from '../../auth';

const FormItem = Form.Item;
const Option = Select.Option;
let uuid = 0;
let k = 1;


class SearchAlumniFilterClass extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props,
            preference: { "Formula": '', "Expressions": [] },
            quicksearch: {},
            formvalues: {},
            affinityGroupsKey: [],
            scoutingAffiliationKey: [],
            ethnicityKey: [],
            nationalAwardKey: [],
            councilAffiliationKey: [],
            membershipStatusKey: [],
            emailFilterKey: [],
            eagleCouncilFilterKey: [],
            phoneFilterKey: [],
        }
    }

    removeFilter = () => {
        const { form } = this.props;
        const keys = form.getFieldValue('keys');
        keys.map((e) => this.remove(e))
        this.add()
        localStorage.removeItem('QuickSearchExp')
        localStorage.removeItem('ContextToken')
        window.location.reload()
        //this.props.actions.QuickSearchAlumni(columns, '')
    }

    remove = (k) => {
        const { form } = this.props;
        // can use data-binding to get
        const keys = form.getFieldValue('keys');
        // if (keys.length === 1) {
        //     message.warning('You can not remove all filter.');
        //     return
        // }
        // can use data-binding to set
        form.setFieldsValue({
            keys: keys.filter(key => key !== k),
        });
    }

    add = () => {
        const { form } = this.props;
        // can use data-binding to get
        const keys = form.getFieldValue('keys');
        const nextKeys = keys.concat(uuid);
        uuid++;
        // can use data-binding to set
        // important! notify form to detect changes
        form.setFieldsValue({
            keys: nextKeys,
        });
    }

    handleSubmit = (e) => {
        const {ethnicities} = this.props
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            let IsAlumniSearch;
            (this.props.location.pathname == '/alumni-search') ? IsAlumniSearch = true : IsAlumniSearch = false
            if (!err) {
                const removeEmpty = (arraycolumn, element) => arraycolumn.filter((e) => e !== element)
                let arraycolumn = removeEmpty(values.column, null)
                let ArrLength = arraycolumn.length
                let coulmnsValue = removeEmpty(values.column, null)
                let criteriaValue;
                if (!IsAlumniSearch) { criteriaValue = removeEmpty(values.criteria, null) }
                let searchValues = removeEmpty(values.value, null)
                let formula = ''
                let expressions = []
                let queryfilter = []
                let Query = ''
                let columnlist = []
                let Key_Index = ''
                for (let i = 0; i < ArrLength; i++) {
                    //Showing error message
                    if (coulmnsValue[i] == "firstname" || coulmnsValue[i] == "lastname" || coulmnsValue[i] == "eaglecouncilnameandnumber") {
                        if (searchValues[i].length < 3) {
                            notification['error']({
                                message: 'Error',
                                description:
                                    'First Name, Last Name or Eagle Scout Council should contain minimum 3 characters to search.',
                            });
                            //this.refs['error' + i].innerText = "Please enter 3 characters to search";
                            return false
                        }
                        // else {
                        //     //this.refs['error' + i].innerText = "";
                        // }
                    }
                    //Add leading zeroes, when necessary, to make the searchable unit number 4 digits long 
                    if (coulmnsValue[i] == "EagleScoutUnitNumber") {
                        let unitNumber = searchValues[i]
                        while (unitNumber.length < 4) unitNumber = "0" + unitNumber;
                        searchValues[i] = unitNumber
                    }
                    Query += " " + coulmnsValue[i] + " " + (IsAlumniSearch ? ((coulmnsValue[i] == "firstname" || coulmnsValue[i] == "lastname" || coulmnsValue[i] == "eaglecouncilnameandnumber") ? "START" : "EQ") : criteriaValue[i]) + " " + searchValues[i]
                    Key_Index = values.keys[i]
                    if (values.operator && values.operator[Key_Index]) { formula += " " + values.operator[Key_Index] + " " }
                    formula += '@exp' + i
                    expressions.push({
                        "ExpressionName": "exp" + i,
                        "ColumnName": coulmnsValue[i],
                        "Operator": IsAlumniSearch ? ((coulmnsValue[i] == "firstname" || coulmnsValue[i] == "lastname" || coulmnsValue[i] == "eaglecouncilnameandnumber") ? "START" : "EQ") : criteriaValue[i],
                        "Value": searchValues[i]
                    })

                    queryfilter.push({
                        "opertator": "",
                        "column": coulmnsValue[i],
                        "condition": IsAlumniSearch ? ((coulmnsValue[i] == "firstname" || coulmnsValue[i] == "lastname" || coulmnsValue[i] == "eaglecouncilnameandnumber") ? "START" : "EQ") : criteriaValue[i],
                        "value": searchValues[i],
                    })
                    columnlist.push(coulmnsValue[i])
                }
                columnlist.push('personGUID', 'firstname', 'lastname', 'email', 'phonenumber', 'home_city', 'home_state', 'home_zip5', 'eaglecouncilnameandnumber', 'EagleScoutUnitNumber', 'EagleScoutUnitCity', 'EagleScoutUnitState', 'FacebookName', 'InstagramName','TwitterName', 'LinkedinName','membershiptype','AffinityGroup','membershipstatus')
                this.state.preference.Formula = formula
                this.state.preference.Expressions = expressions
                localStorage.setItem('QuickSearchExp', JSON.stringify(values))

                let maxRecord = 0;
                if (expressions) {
                    let columnName = "membershipstatus";
                    let value = 'active';

                    expressions.forEach(function (obj) {
                        if (obj.Value === "National Eagle Scout Association") {
                            obj.ColumnName = columnName;
                            obj.Value = value;
                            maxRecord = 10000;
                        }
                        if (obj.ColumnName.toLowerCase() === "ethnicity") {
                            obj.ColumnName = "EthnicityID";
                            const ethnicity = ethnicities.find(item => item.name.toLowerCase() === obj.Value.toLowerCase());
                            
                            if (ethnicity) {
                                obj.Value = ethnicity.id; // Set the id from the ethnicity object
                            }
                        }
                    })
                }


                this.props.actions.savelist(this.state.preference, 'quicksearch', '4', columnlist, false, this.props.perPageSize, 1, maxRecord) // 1 => page
                this.props.filterColumn(columnlist)
                this.props.preference(this.state.preference)
                this.props.Removefilter()
                // this.setState({
                //     formvalues: values
                // })
                this.props.currentpageHandler()
                if (this.props.location.pathname == '/admin-dashboard') {
                    history.push('/quick-search')
                }
            }
        });

    }

    renderCouncilAffiliations = () => {
        if(this.props.councils && this.props.councils.length != 0) return this.props.councils.map(eachCouncil => <Option value={eachCouncil.councilLong}>{eachCouncil.councilLong}</Option>)
        else return <Option value=''>Loading...</Option>
    }

    renderEthnicity = () => {
        if (this.props.ethnicities && Array.isArray(this.props.ethnicities) && this.props.ethnicities.length > 0 && !this.props.ethnicities_loading ) {
            return this.props.ethnicities.map(ethnicity =>  <Option key={ethnicity.id} value={ethnicity.name}>{ethnicity.name}</Option>)
        }
    }
    renderInitialEthnicityValue = (initialValue) => {
        const selectedEthnicity = this.props.ethnicities.find(ethnicity => ethnicity.id.toString() === initialValue.toString());
        if (selectedEthnicity) {
            return selectedEthnicity.name; // Return the id as initialValue for the Select field
        }
        return ''; // Default value if no match found
    }


    componentWillReceiveProps = (nextProps) => {
        const hasEthnicities = nextProps.ethnicities && nextProps.ethnicities.length > 0;
        if (hasEthnicities) {
            const quicksearch = JSON.parse(localStorage.getItem('QuickSearchExp')) || undefined;
            if (quicksearch) {
                const ethnicityColumnIndex = quicksearch.column ? quicksearch.column.indexOf("ethnicity") : -1;
                if (ethnicityColumnIndex !== -1 && quicksearch.value) {
                     nextProps.ethnicities.map(item => {
                        if(item.id.toString() == quicksearch.value[ethnicityColumnIndex]){
                            return quicksearch.value[ethnicityColumnIndex] = item.name
                        }
                    }
                        )
    
                    this.setState({ quicksearch });
                }
            }
        }
    }

    componentDidMount = (e) => {
        this.props.actions.isadmin()
        if (localStorage.getItem('QuickSearchExp')) {
            let quicksearch = JSON.parse(localStorage.getItem('QuickSearchExp'))
            this.setState({
                quicksearch: quicksearch
            })
            let keylength = quicksearch.keys ? quicksearch.keys.length : 0
            for (let i = 0; i < keylength; i++) {
                this.add()
            }
            localStorage.removeItem('QuickSearchExp')
        } else {
            this.add()
        }

        if(!this.props.councils) this.props.actions.getallcouncils()
        
        this.props.actions.getEthnicities();
        localStorage.removeItem('QuickSearchExp')
    }


    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { isadmin, isspecialist } = this.props;
        const quicksearch = this.state.quicksearch
        getFieldDecorator('keys', { initialValue: [] });
        const keys = getFieldValue('keys');
        let keyvalue = quicksearch.keys;
        let keyindex = ''

        const formItems = keys.map((k, index) => {
            if (keyvalue) keyindex = keyvalue[index]
            return (
                <Row type="flex" align="middle" justify="space-around">
                    {index == 0 && <Col xs={23} sm={23} md={3} lg={3}></Col>}
                    {index != 0 &&
                        <Col xs={23} sm={23} md={3} lg={3}>

                            <FormItem
                                vertical
                                key={k}
                                hasFeedback
                            >
                                {getFieldDecorator(`operator[${k}]`, {
                                    validateTrigger: ['onChange', 'onBlur'],
                                    rules: [{
                                        required: true
                                    }],
                                    initialValue: ((Object.keys(quicksearch).length !== 0) && quicksearch.operator) ? quicksearch.operator[keyindex] : ''
                                })(
                                    <Select
                                        placeholder="operator"
                                        showSearch
                                        style={{ width: '100%' }}
                                    >
                                        <Option value="AND">AND</Option>
                                        <Option value="OR">OR</Option>
                                        <Option value="AND NOT">AND NOT</Option>
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                    }
                    <Col xs={23} sm={23} md={6} lg={6}>
                        {(isadmin == true) &&
                            <FormItem
                            vertical
                            key={k}
                            hasFeedback
                        >
                            {getFieldDecorator(`column[${k}]`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                rules: [{
                                    required: true
                                }],
                                initialValue: ((Object.keys(quicksearch).length !== 0) && quicksearch.column[keyindex]) ? quicksearch.column[keyindex] : ''
                            })(
                                <Select
                                    placeholder="Select Column name"
                                    showSearch
                                    style={{ width: '100%' }}
                                    onChange={(value) => {
                                        const keys = {
                                            scoutingAffiliationKeys: [...this.state.scoutingAffiliationKey, index],
                                            ethnicityKeys: [...this.state.ethnicityKey, index],
                                            nationalAwardKeys: [...this.state.nationalAwardKey, index],
                                            affinityKeys: [...this.state.affinityGroupsKey, index],
                                            councilAffiliationKeys: [...this.state.councilAffiliationKey, index],
                                            membershipStatusKey: [...this.state.membershipStatusKey, index],
                                            emailFilterKeys: [...this.state.emailFilterKey, index],
                                            eagleCouncilFilterKeys: [...this.state.eagleCouncilFilterKey, index],
                                            phoneFilterKeys: [...this.state.phoneFilterKey, index]
                                        };
                        
                                        const removeIndex = (keyArray) => {
                                            return keyArray.filter(e => e !== index) || [];
                                        };
                        
                                        // Handle adding keys based on value
                                        const updateState = (key, value) => {
                                            this.setState({ [key]: value });
                                        };
                        
                                        const handleSelection = (value) => {
                                            switch (value) {
                                                case 'ScoutingAffiliation':
                                                    console.log("Scouting Affiliation", value);
                                                    updateState('scoutingAffiliationKey', keys.scoutingAffiliationKeys);
                                                    break;
                                                case 'ethnicity':
                                                    console.log("ethnicityKey", value);
                                                    updateState('ethnicityKey', keys.ethnicityKeys);
                                                    break;
                                                case 'email':
                                                    console.log("Email", value);
                                                    updateState('emailFilterKey', keys.emailFilterKeys);
                                                    break;
                                                case 'NationalAward':
                                                    console.log("National Award", value);
                                                    updateState('nationalAwardKey', keys.nationalAwardKeys);
                                                    break;
                                                case 'CouncilAffiliation':
                                                    console.log("Council Affiliation", value);
                                                    updateState('councilAffiliationKey', keys.councilAffiliationKeys);
                                                    break;
                                                case 'AffinityGroup':
                                                    console.log("Affinity Group", value);
                                                    updateState('affinityGroupsKey', keys.affinityKeys);
                                                    break;
                                                case 'membershipStatus':
                                                    console.log("Membership Status", value);
                                                    updateState('membershipStatusKey', keys.membershipStatusKey);
                                                    break;
                                                case 'eaglecouncilnameandnumber':
                                                    console.log("Eagle Scout Council", value);
                                                    updateState('eagleCouncilFilterKey', keys.eagleCouncilFilterKeys);
                                                    break;
                                                case 'phonenumber':
                                                    console.log("Phone Number", value);
                                                    updateState('phoneFilterKey', keys.phoneFilterKeys);
                                                    break;
                                                default:
                                                    ['scoutingAffiliationKey', 'councilAffiliationKey', 'membershipStatusKey', 'affinityGroupsKey', 'eagleCouncilFilterKey', 'emailFilterKey', 'phoneFilterKey'].forEach(key => {
                                                        if (this.state[key].includes(index)) {
                                                            updateState(key, removeIndex(this.state[key]));
                                                        }
                                                    });
                                            }
                                        };
                        
                                        handleSelection(value);
                                    }}
                                >
                                    <Option value="firstname">First Name</Option>
                                    <Option value="lastname">Last Name</Option>
                                    <Option value="email">Email</Option>
                                    <Option value="phonenumber">Phone Number</Option>
                                    <Option value="home_city">City</Option>
                                    <Option value="home_state">State</Option>
                                    <Option value="home_zip5">Zip/Postal Code</Option>
                                    <Option value="ethnicity">Ethnicity</Option>
                                    <Option value="eaglecouncilnameandnumber">Eagle Scout Council</Option>
                                    <Option value="EagleScoutUnitNumber">Eagle Unit Number</Option>
                                    <Option value="EagleScoutUnitCity">Eagle Unit City</Option>
                                    <Option value="EagleScoutUnitState">Eagle Unit State</Option>
                                    {!(this.props.isCSTSupport || this.props.isCouncilCommittee) && (
                                        <Option value="CouncilAffiliation">Council Affiliations</Option>
                                    )}
                                    <Option value="ScoutingAffiliation">Scouting Affiliation</Option>
                                    <Option value="NationalAward">National Award</Option>
                                    {this.state.affinityGroupsKey.length === 0 && <Option value="AffinityGroup">Affinity Group</Option>}
                                    <Option value="membershipStatus">Membership Status</Option>
                                </Select>
                            )}
                        </FormItem>
                        
                        }
                        {isadmin == false &&
                            <FormItem
                                vertical
                                key={k}
                                hasFeedback
                            >
                                {getFieldDecorator(`column[${k}]`, {
                                    validateTrigger: ['onChange', 'onBlur'],
                                    rules: [
                                        {
                                            required: true,
                                            // message: "Phone number is required"
                                        },
                                        // {
                                        //     pattern: /^\d+$/,  // Allows only digits
                                        //     message: "Phone number must contain only digits"
                                        // },
                                        // {
                                        //     len: 10,  // Sets the length to exactly 10 characters
                                        //     message: "Phone number must be exactly 10 characters"
                                        // }
                                    ],
                                    initialValue: ((Object.keys(quicksearch).length !== 0) && quicksearch.column[keyindex]) ? quicksearch.column[keyindex] : ''
                                })(

                                    <Select
                                        placeholder="Select Column name"
                                        showSearch
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            let scoutingAffiliationKeys = [...this.state.scoutingAffiliationKey, index]
                                            let ethnicityKeys = [...this.state.ethnicityKey, index]
                                            const nationalAwardKeys = [...this.state.nationalAwardKey, index]
                                            const affinityKeys = [...this.state.affinityGroupsKey, index]
                                            const councilAffiliationKeys = [...this.state.councilAffiliationKey, index]
                                            const membershipStatusKey = [...this.state.membershipStatusKey, index]
                                            const emailFilterKeys = [...this.state.emailFilterKey, index]
                                            const phoneFilterKeys = [...this.state.phoneFilterKey, index]
                                            if (value == 'ScoutingAffiliation') {
                                                console.log("Scouting Affiliation", value);
                                                this.setState({
                                                    scoutingAffiliationKey: scoutingAffiliationKeys
                                                })

                                                if(ethnicityKeys.includes(index)){
                                                    let getFilteredEthnicityKeys = ethnicityKeys.filter(e =>e != index)
                                                    this.setState({
                                                        ethnicityKeys: getFilteredEthnicityKeys == undefined ? [] : getFilteredEthnicityKeys
                                                    })
                                                }
                                                if(councilAffiliationKeys.includes(index)){
                                                    let getFilteredCouncilAffilitations = councilAffiliationKeys.filter(e =>e != index)
                                                    this.setState({
                                                        councilAffiliationKey: getFilteredCouncilAffilitations == undefined ? [] : getFilteredCouncilAffilitations
                                                    })
                                                }
                                                
                                                if(affinityKeys.includes(index)){
                                                    let getFilteredAffinityKeys = affinityKeys.filter(e =>e != index)
                                                    this.setState({
                                                        affinityGroupsKey: getFilteredAffinityKeys== undefined ? [] : getFilteredAffinityKeys  
                                                    })
                                                }

                                            }
                                            else if (value == 'ethnicity') {
                                                console.log("Ethnicity", value);
                                                this.setState({
                                                    ethnicityKey: ethnicityKeys
                                                })

                                                if(scoutingAffiliationKeys.includes(index)){
                                                    let getFilteredAffilitations = scoutingAffiliationKeys.filter(e =>e != index)
                                                    this.setState({
                                                        scoutingAffiliationKey: getFilteredAffilitations == undefined ? [] : getFilteredAffilitations
                                                    })
                                                }

                                                if(councilAffiliationKeys.includes(index)){
                                                    let getFilteredCouncilAffilitations = councilAffiliationKeys.filter(e =>e != index)
                                                    this.setState({
                                                        councilAffiliationKey: getFilteredCouncilAffilitations == undefined ? [] : getFilteredCouncilAffilitations
                                                    })
                                                }
                                                
                                                if(affinityKeys.includes(index)){
                                                    let getFilteredAffinityKeys = affinityKeys.filter(e =>e != index)
                                                    this.setState({
                                                        affinityGroupsKey: getFilteredAffinityKeys== undefined ? [] : getFilteredAffinityKeys  
                                                    })
                                                }

                                            }
                                            else if (value == 'email') {
                                                console.log("Email ", value);
                                                this.setState({
                                                    emailFilterKey: emailFilterKeys
                                                })
                                                if(scoutingAffiliationKeys.includes(index)){
                                                    let getFilteredAffilitations = scoutingAffiliationKeys.filter(e =>e != index)
                                                    this.setState({
                                                        scoutingAffiliationKey: getFilteredAffilitations == undefined ? [] : getFilteredAffilitations
                                                    })
                                                }
                                                if(ethnicityKeys.includes(index)){
                                                    let getFilteredEthnicityKeys = ethnicityKeys.filter(e =>e != index)
                                                    this.setState({
                                                        ethnicityKeys: getFilteredEthnicityKeys == undefined ? [] : getFilteredEthnicityKeys
                                                    })
                                                }
                                                if(councilAffiliationKeys.includes(index)){
                                                    let getFilteredCouncilAffilitations = councilAffiliationKeys.filter(e => e != index)
                                                    this.setState({
                                                        councilAffiliationKey: getFilteredCouncilAffilitations == undefined ? [] : getFilteredCouncilAffilitations
                                                    })
                                                }

                                                if(affinityKeys.includes(index)){
                                                    let getFilteredAffinityKeys = affinityKeys.filter(e =>  e != index)
                                                    this.setState({
                                                        affinityGroupsKey: getFilteredAffinityKeys== undefined ? [] : getFilteredAffinityKeys  
                                                    })
                                                }

                                                if(membershipStatusKey.includes(index)){
                                                    let getFilteredMembershipStatus = membershipStatusKey.filter(e => e != index)
                                                    this.setState({
                                                        membershipStatusKey: getFilteredMembershipStatus == undefined ? [] : getFilteredMembershipStatus
                                                    })
                                                }

                                            }
                                            
                                            else if (value === 'phonenumber') {
                                                console.log("Phone Number", value);
                                                this.setState({
                                                    phoneFilterKey: phoneFilterKeys
                                                });
                                            
                                                // Filter out any keys that should not apply to 'phonenumber' field here
                                                if (scoutingAffiliationKeys.includes(index)) {
                                                    let getFilteredAffilitations = scoutingAffiliationKeys.filter(e => e != index);
                                                    this.setState({
                                                        scoutingAffiliationKey: getFilteredAffilitations === undefined ? [] : getFilteredAffilitations
                                                    });
                                                }
                                                if(ethnicityKeys.includes(index)){
                                                    let getFilteredEthnicityKeys = ethnicityKeys.filter(e =>e != index)
                                                    this.setState({
                                                        ethnicityKeys: getFilteredEthnicityKeys == undefined ? [] : getFilteredEthnicityKeys
                                                    })
                                                }
                                                if (councilAffiliationKeys.includes(index)) {
                                                    let getFilteredCouncilAffilitations = councilAffiliationKeys.filter(e => e != index);
                                                    this.setState({
                                                        councilAffiliationKey: getFilteredCouncilAffilitations === undefined ? [] : getFilteredCouncilAffilitations
                                                    });
                                                }
                                            
                                                if (affinityKeys.includes(index)) {
                                                    let getFilteredAffinityKeys = affinityKeys.filter(e => e != index);
                                                    this.setState({
                                                        affinityGroupsKey: getFilteredAffinityKeys === undefined ? [] : getFilteredAffinityKeys
                                                    });
                                                }
                                                
                                                if (membershipStatusKey.includes(index)) {
                                                    let getFilteredMembershipStatus = membershipStatusKey.filter(e => e != index);
                                                    this.setState({
                                                        membershipStatusKey: getFilteredMembershipStatus === undefined ? [] : getFilteredMembershipStatus
                                                    });
                                                }
                                            }
                                            
                                            else if (value == 'NationalAward') {
                                                console.log("National Award", value);
                                                this.setState({
                                                    nationalAwardKey: nationalAwardKeys
                                                })
                                                if(ethnicityKeys.includes(index)){
                                                    let getFilteredEthnicityKeys = ethnicityKeys.filter(e =>e != index)
                                                    this.setState({
                                                        ethnicityKeys: getFilteredEthnicityKeys == undefined ? [] : getFilteredEthnicityKeys
                                                    })
                                                }
                                                if(scoutingAffiliationKeys.includes(index)){
                                                    let getFilteredAffilitations = scoutingAffiliationKeys.filter(e =>e != index)
                                                    this.setState({
                                                        scoutingAffiliationKey: getFilteredAffilitations == undefined ? [] : getFilteredAffilitations
                                                    })
                                                }

                                                if(councilAffiliationKeys.includes(index)){
                                                    let getFilteredCouncilAffilitations = councilAffiliationKeys.filter(e => e != index)
                                                    this.setState({
                                                        councilAffiliationKey: getFilteredCouncilAffilitations == undefined ? [] : getFilteredCouncilAffilitations
                                                    })
                                                }

                                                if(affinityKeys.includes(index)){
                                                    let getFilteredAffinityKeys = affinityKeys.filter(e =>e != index)
                                                    this.setState({
                                                        affinityGroupsKey: getFilteredAffinityKeys== undefined ? [] : getFilteredAffinityKeys  
                                                    })
                                                }

                                            }
                                            else if (value == 'CouncilAffiliation') {
                                                console.log("Council Affiliation", value);
                                                this.setState({
                                                    councilAffiliationKey: councilAffiliationKeys
                                                })

                                                if(scoutingAffiliationKeys.includes(index)){
                                                    let getFilteredAffilitations = scoutingAffiliationKeys.filter(e =>e != index)
                                                    this.setState({
                                                        scoutingAffiliationKey: getFilteredAffilitations == undefined ? [] : getFilteredAffilitations
                                                    })
                                                }
                                                if(ethnicityKeys.includes(index)){
                                                    let getFilteredEthnicityKeys = ethnicityKeys.filter(e =>e != index)
                                                    this.setState({
                                                        ethnicityKeys: getFilteredEthnicityKeys == undefined ? [] : getFilteredEthnicityKeys
                                                    })
                                                }
                                                if(affinityKeys.includes(index)){
                                                    let getFilteredAffinityKeys = affinityKeys.filter(e =>e != index)
                                                    this.setState({
                                                        affinityGroupsKey: getFilteredAffinityKeys== undefined ? [] : getFilteredAffinityKeys  
                                                    })
                                                }

                                            }
                                            else if (value === 'AffinityGroup'){
                                               console.log('Affinity Group', value);
                                                this.setState({
                                                    affinityGroupsKey: affinityKeys
                                                })
                                                console.log('Affinity Keys', affinityKeys);

                                               if(scoutingAffiliationKeys.includes(index)){
                                                    let getFilteredAffilitations = scoutingAffiliationKeys.filter(e =>e != index)
                                                    this.setState({
                                                        scoutingAffiliationKey: getFilteredAffilitations == undefined ? [] : getFilteredAffilitations
                                                    })
                                                }
                                                if(ethnicityKeys.includes(index)){
                                                    let getFilteredEthnicityKeys = ethnicityKeys.filter(e =>e != index)
                                                    this.setState({
                                                        ethnicityKeys: getFilteredEthnicityKeys == undefined ? [] : getFilteredEthnicityKeys
                                                    })
                                                }
                                                if(councilAffiliationKeys.includes(index)){
                                                    let getFilteredCouncilAffilitations = councilAffiliationKeys.filter(e =>e != index)
                                                    this.setState({
                                                        councilAffiliationKey: getFilteredCouncilAffilitations == undefined ? [] : getFilteredCouncilAffilitations
                                                    })
                                                }

                                            }
                                            else {
                                                
                                                if(scoutingAffiliationKeys.includes(index)){
                                                    let getFilteredAffilitations = scoutingAffiliationKeys.filter(e => e != index)
                                                    this.setState({
                                                        scoutingAffiliationKey: getFilteredAffilitations == undefined ? [] : getFilteredAffilitations
                                                    })
                                                }

                                                if(councilAffiliationKeys.includes(index)){
                                                    let getFilteredCouncilAffilitations = councilAffiliationKeys.filter(e =>e != index)
                                                    this.setState({
                                                        councilAffiliationKey: getFilteredCouncilAffilitations == undefined ? [] : getFilteredCouncilAffilitations
                                                    })
                                                }
                                                if(ethnicityKeys.includes(index)){
                                                    let getFilteredEthnicityKeys = ethnicityKeys.filter(e =>e != index)
                                                    this.setState({
                                                        ethnicityKeys: getFilteredEthnicityKeys == undefined ? [] : getFilteredEthnicityKeys
                                                    })
                                                }
                                                if(affinityKeys.includes(index)){
                                                    let getFilteredAffinityKeys = affinityKeys.filter(e =>  e != index)
                                                    this.setState({
                                                        affinityGroupsKey: getFilteredAffinityKeys== undefined ? [] : getFilteredAffinityKeys  
                                                    })
                                                }
                                            
                                            }
                                            
                                        } }
                                    >
                                        <Option value="firstname">First Name</Option>
                                        <Option value="lastname">Last Name</Option>
                                        <Option value="email">Email</Option>
                                        <Option value="phonenumber">Phone Number</Option>
                                        <Option value="home_city">City</Option>
                                        <Option value="home_state">State</Option>
                                        <Option value="home_zip5">Zip/Postal Code</Option>
                                        <Option value="ethnicity">Ethnicity</Option>
                                        <Option value="eaglecouncilnameandnumber">Eagle Scout Council</Option>
                                        <Option value="EagleScoutUnitNumber">Eagle Unit Number</Option>
                                        <Option value="EagleScoutUnitCity">Eagle Unit City</Option>
                                        <Option value="EagleScoutUnitState">Eagle Unit State</Option>
                                        {!(this.props.isCSTSupport || this.props.isCouncilCommittee) && (
                                            <Option value="CouncilAffiliation">Council Affiliations</Option>
                                        )}
                                        <Option value="ScoutingAffiliation">Scouting Affiliation</Option>
                                        <Option value="NationalAward">National Award</Option>
                                        {
                                            this.state.affinityGroupsKey.length > 0 ? "" : <Option value="AffinityGroup">Affinity Group</Option>
                                        }
                                    </Select>

                                )}

                            </FormItem>
                        }
                    </Col>
                    {this.props.location.pathname !== '/alumni-search' && (
                        <Col xs={23} sm={23} md={5} lg={5}>
                            {(() => {
                                const quickSearchCriteriaAvailable = Object.keys(quicksearch).length !== 0; //cache filters
                                const getColumnCondition = (column) => {
                                    const filterKey = `${column.charAt(0).toLowerCase()}${column.slice(1)}Key`;
                                    return this.state[filterKey] == 0 && quickSearchCriteriaAvailable && quicksearch.column[keyindex] === column; 
                                }

                                const hasSelectedFilters =
                                    this.state.scoutingAffiliationKey.length !== 0 ||
                                    this.state.ethnicityKey.length !== 0 ||
                                    this.state.councilAffiliationKey.length !== 0 ||
                                    this.state.affinityGroupsKey.length !== 0 ||
                                    this.state.membershipStatusKey.length !== 0 ||
                                    this.state.nationalAwardKey.length !== 0 ||
                                    this.state.eagleCouncilFilterKey.length !== 0 ||
                                    this.state.phoneFilterKey.length !== 0;

                                const shouldUseSpecificFilter =
                                    getColumnCondition('membershipStatus') || getColumnCondition('ethnicity') ||
                                    getColumnCondition('ScoutingAffiliation') || getColumnCondition('AffinityGroup') || 
                                    getColumnCondition('CouncilAffiliation') || getColumnCondition('NationalAward') ||
                                    getColumnCondition('eaglecouncilnameandnumber') || getColumnCondition('phonenumber');

                                return (
                                    <FormItem vertical hasFeedback>
                                        {getFieldDecorator(`criteria[${k}]`, {
                                            validateTrigger: ['onChange', 'onBlur'],
                                            rules: [{ required: true }],
                                            initialValue: quickSearchCriteriaAvailable ? quicksearch.criteria[keyindex] : '',
                                        })(
                                            (this.state.emailFilterKey.length !== 0 || getColumnCondition('email') ? (
                                                <Select showSearch placeholder="Filter by" style={{ width: '100%' }}>
                                                    <Option value="EQ">Equal to</Option>
                                                    <Option value="INCLUDE">Include</Option>
                                                    <Option value="START">Start with</Option>
                                                </Select>
                                            ) : (
                                                hasSelectedFilters || shouldUseSpecificFilter ? (
                                                    <Select showSearch placeholder="Filter by" style={{ width: '100%' }}>
                                                        <Option value="EQ">Equal to</Option>
                                                    </Select>
                                                ) : (
                                                    <Select showSearch placeholder="Filter by" style={{ width: '100%' }}>
                                                        <Option value="EQ">Equal to</Option>
                                                        <Option value="GT">Greater than</Option>
                                                        <Option value="LT">Less than</Option>
                                                        <Option value="GE">Greater than or equal to</Option>
                                                        <Option value="LE">Less than or equal to</Option>
                                                        <Option value="INCLUDE">Include</Option>
                                                        <Option value="START">Start with</Option>
                                                    </Select>
                                                )
                                            ))
                                        )}
                                    </FormItem>
                                );
                            })()}
                        </Col>
                    )}
                    
                    <Col xs={23} sm={23} md={5} lg={5}>
                    { this.state.scoutingAffiliationKey.length !=0 && this.state.scoutingAffiliationKey.includes(index) || (!this.state.scoutingAffiliationKey && (Object.keys(quicksearch).length !== 0) && quicksearch.column[keyindex] == 'ScoutingAffiliation' ) ? 
                        <FormItem
                            vertical
                            hasFeedback
                            className='searchField'
                        // {...this.state.charerror[k] && {
                        //     help: 'Please enter three characters',
                        //     validateStatus: 'error',
                        // }}
                        >
                            {getFieldDecorator(`value[${k}]`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                rules: [{ required: true, message: '' }],
                                initialValue: ((Object.keys(quicksearch).length !== 0) && quicksearch.value[keyindex]) ? quicksearch.value[keyindex] : ''
                            })(
                                <Select
                                showSearch
                                placeholder="Affiliations"
                                style={{ width: '100%' }}
                            >
                                <Option value="Alpha Phi Omega">Alpha Phi Omega</Option>
                                <Option value="Alumni Association">Alumni Association</Option>
                                <Option value="American Wood Badge Alumni">American Wood Badge Alumni</Option>
                                <Option value="Charles L. Sommers Alumni Association">Charles L. Sommers Alumni Association</Option>
                                <Option value="National Eagle Scout Association">National Eagle Scout Association</Option>
                                <Option value="National Organization of Sea Scout Alumni">National Organization of Sea Scout Alumni</Option>
                                <Option value="Order of the Arrow Alliance">Order of the Arrow Alliance</Option>
                                <Option value="Philmont Staff Association">Philmont Staff Association</Option>
                                <Option value="SBR Staff Association">SBR Staff Association </Option>
                                <Option value="Sea Base Alumni & Friends">Sea Base Alumni & Friends</Option>
                                <Option value="Venturing Alumni">Venturing Alumni</Option>
                            </Select>
                            )} </FormItem> 

                            : this.state.nationalAwardKey.length !=0 && this.state.nationalAwardKey.includes(index) || (!this.state.nationalAwardKey && (Object.keys(quicksearch).length !== 0) && quicksearch.column[keyindex] == 'NationalAward' ) ? 
                            <FormItem
                                vertical
                                hasFeedback
                                className='searchField'
                            // {...this.state.charerror[k] && {
                            //     help: 'Please enter three characters',
                            //     validateStatus: 'error',
                            // }}
                            >
                                {getFieldDecorator(`value[${k}]`, {
                                    validateTrigger: ['onChange', 'onBlur'],
                                    rules: [{ required: true, message: '' }],
                                    initialValue: ((Object.keys(quicksearch).length !== 0) && quicksearch.value[keyindex]) ? quicksearch.value[keyindex] : ''
                                })(
                                    <Select
                                    showSearch
                                    placeholder="NationalAward"
                                    style={{ width: '100%' }}
                                >
                                   {nationalAwards.map(nationalAward => <Option value={nationalAward}>{nationalAward}</Option>)}
                                </Select>
                                )} </FormItem> 
                            : (this.state.councilAffiliationKey.length !=0 && this.state.councilAffiliationKey.includes(index) || (!this.state.councilAffiliationKey && (Object.keys(quicksearch).length !== 0) && quicksearch.column[keyindex] == 'CouncilAffiliation' )) || (this.state.eagleCouncilFilterKey.length !=0 && this.state.eagleCouncilFilterKey.includes(index) || (!this.state.eagleCouncilFilterKey && (Object.keys(quicksearch).length !== 0) && quicksearch.column[keyindex] == 'eaglecouncilnameandnumber' ))  ? 
                            <FormItem
                                vertical
                                hasFeedback
                                className='searchField'
                            // {...this.state.charerror[k] && {
                            //     help: 'Please enter three characters',
                            //     validateStatus: 'error',
                            // }}
                            >
                                {getFieldDecorator(`value[${k}]`, {
                                    validateTrigger: ['onChange', 'onBlur'],
                                    rules: [{ required: true, message: '' }],
                                    initialValue: ((Object.keys(quicksearch).length !== 0) && quicksearch.value[keyindex]) ? quicksearch.value[keyindex] : ''
                                })(
                                    <Select
                                    showSearch
                                    placeholder="Affiliations"
                                    style={{ width: '100%' }}
                                >
                                   {this.renderCouncilAffiliations()}
                                </Select>
                                )} </FormItem> 
                                : this.state.affinityGroupsKey.length !=0 && this.state.affinityGroupsKey.includes(index) || (!this.state.affinityGroupsKey && (Object.keys(quicksearch).length !== 0) && quicksearch.column[keyindex] == 'AffinityGroup' ) ? 
                            <FormItem
                            vertical
                            hasFeedback
                            className='searchField'
                        // {...this.state.charerror[k] && {
                        //     help: 'Please enter three characters',
                        //     validateStatus: 'error',
                        // }}
                        >
                            {getFieldDecorator(`value[${k}]`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                rules: [{ required: true, message: '' }],
                                initialValue: ((Object.keys(quicksearch).length !== 0) && quicksearch.value[keyindex]) ? quicksearch.value[keyindex] : ''
                            })(
                                <Select
                                showSearch
                                placeholder="Affiliations"
                                style={{ width: '100%' }}
                            >
                                <Option value="Educators">Educators</Option>
                                <Option value="Emergency Management">Emergency Management</Option>
                                <Option value="Firefighters">Firefighters</Option>
                                <Option value="Health Care Professionals">Health Care Professionals</Option>
                                <Option value="Law Enforcement">Law Enforcement</Option>
                                <Option value="Legal">Legal</Option>
                                <Option value="Military and Citadel Scout Association">Military and Citadel Scout Association</Option>
                                <Option value="Muslim Scout Association">Muslim Scout Association</Option>
                                <Option value="Natural Resources">Natural Resources</Option>
                                <Option value="Retired Professional Scouters">Retired Professional Scouters</Option>
                            </Select>
                            )} </FormItem> 
                            
                            : (this.state.membershipStatusKey.length !=0 && this.state.membershipStatusKey.includes(index)) || (!this.state.membershipStatusKey && (Object.keys(quicksearch).length !== 0) && quicksearch.column[keyindex] == 'membershipStatus' ) ?
                            <FormItem
                            vertical
                            hasFeedback
                            className='searchField'
                        // {...this.state.charerror[k] && {
                        //     help: 'Please enter three characters',
                        //     validateStatus: 'error',
                        // }}
                        >
                            {getFieldDecorator(`value[${k}]`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                rules: [{ required: true, message: '' }],
                                initialValue: ((Object.keys(quicksearch).length !== 0) && quicksearch.value[keyindex]) ? quicksearch.value[keyindex] : ''
                            })(
                                <Select
                                showSearch
                                placeholder="membershipStatus"
                                style={{ width: '100%' }}
                            >
                                <Option value="active">Active</Option>
                                <Option value="expired">Expired</Option>
                                <Option value="inActive">Inactive</Option>
                                <Option value="lapsed">Lapsed</Option>
                                <Option value="upgrade">Upgrade</Option>
                            </Select>
                            )} </FormItem> 
                            : (this.state.ethnicityKey.length !=0 && this.state.ethnicityKey.includes(index)) || (!this.state.ethnicityKey && (Object.keys(quicksearch).length !== 0) && quicksearch.column[keyindex] == 'ethnicity' ) ?
                            <FormItem
                            vertical
                            hasFeedback
                            className='searchField'
                        // {...this.state.charerror[k] && {
                        //     help: 'Please enter three characters',
                        //     validateStatus: 'error',
                        // }}
                        >
                            {getFieldDecorator(`value[${k}]`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                rules: [{ required: true, message: '' }],
                                initialValue: (Object.keys(quicksearch).length !== 0 && quicksearch.value[keyindex])
                                    ? this.renderInitialEthnicityValue(quicksearch.value[keyindex])
                                    : ''
                            })(
                                <Select
                                showSearch
                                placeholder="ethnicity"
                                style={{ width: '100%' }}
                            >
                                {this.renderEthnicity()}
                            </Select>
                            )} </FormItem> 
                            : 
                            <FormItem
                            vertical
                            hasFeedback
                            className='searchField'
                        // {...this.state.charerror[k] && {
                        //     help: 'Please enter three characters',
                        //     validateStatus: 'error',
                        // }}
                        >
                            {getFieldDecorator(`value[${k}]`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                rules: [{ required: true, message: '' }],
                                initialValue: ((Object.keys(quicksearch).length !== 0) && quicksearch.value[keyindex]) ? quicksearch.value[keyindex] : ''
                            })(
                                <Input placeholder="Type Value" />
                            )} 
                        </FormItem> }
                        <span ref={'error' + k} style={{ color: "red" }}></span>
                    </Col>
                    <Col xs={23} sm={23} md={1} lg={1}>
                        <FormItem
                            vertical
                        >
                            {keys.length > 1 ? (
                                <Icon
                                    className="dynamic-delete-button red pointer"
                                    type="minus-circle-o"
                                    disabled={keys.length === 1}
                                    onClick={() => this.remove(k)}
                                />
                            ) : null}
                        </FormItem>
                    </Col>
                </Row>
            );
        });
        return (

            <div>

                <div className='widget'>
                    <div className='widget-container dashboard-search'>
                        <div className="widget-header">
                            <div className='title'>
                                {(this.props.location.pathname == '/alumni-search' || this.props.location.pathname == '/quick-search') ? "Alumni Search" : "Advanced Search"}
                            </div>
                            {/* {this.props.isadmin == true &&
                                <div className='setting'>
                                    <a onClick={() => history.push('/list-and-search')}><i className='fa fa-search margin-right-5'></i> Advanced Search </a>
                                </div>
                            } */}
                        </div>
                        {this.props.ethnicities && this.props.ethnicities.length != 0 && !this.props.ethnicities_loading ?
                        <Form onSubmit={this.handleSubmit}>

                            {formItems}

                            <Row gutter={48} type="flex" justify="start">
                                <Col xs={23} sm={23} md={{ span: 5 }} lg={{ span: 5 }}>
                                    <FormItem>
                                        <Button type="dashed" onClick={this.removeFilter}>
                                            <Icon type="close-circle-o" /> Reset All Filter
                                        </Button>
                                    </FormItem>
                                </Col>
                                <Col xs={23} sm={23} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 10 }}>
                                    <FormItem>
                                        <Button type="dashed" onClick={this.add} >
                                            <Icon type="plus-circle-o" /> Add Another Filter
                                        </Button>
                                    </FormItem>
                                </Col>
                                <Col xs={23} sm={23} md={4} lg={4}>
                                    <FormItem>
                                        <Button type="primary width-100 scout-btn" htmlType="submit"><i class="fa fa-search margin-right-5" aria-hidden="true"></i> Search</Button>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form> 
                            : <div className='page-loading'>
                                <Spin tip="Loading Page..." />
                            </div>
                            }
                    </div>
                </div>
            </div>
        );
    }

}



function mapStateToProps(state) {
    return {
        isadminLoading: state.isadminreducer.loading,
        isadmin: state.isadminreducer.isadmin,
        isspecialist: state.isadminreducer.isspecialist,
        councils: state.councilsreducer.councils,
        ethnicities_loading: state.ethnicitiesreducer.loading,
        ethnicities: state.ethnicitiesreducer.ethnicities,
        positionsLoading: state.GetPositionsReducer.loading,
        postionsinfo: state.GetPositionsReducer.postionsinfo,
        isCSTSupport: state.isadminreducer.isCSTSupport,
        isCouncilCommittee: state.isadminreducer.isCouncilCommittee
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

const SearchAlumniFilter = Form.create()(SearchAlumniFilterClass);


export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(SearchAlumniFilter);


// WEBPACK FOOTER //
// ./src/components/Inc/SearchAlumniFilter.js